/** @format */

import serviceUrls from 'src/constants/serviceUrls';
import axiosRequest from 'src/helpers/axiosRequest';

import { transformFormValues } from 'src/helpers';
const CREATEORGANIZER_PAGESTATES = {
  COMPLETE: 83, // only 83,84 seem to work?
  INCOMPLETE: 84,
  NOT_VISITED: 85,
  CURRENT_NOT_COMPLETE: 86,
  CURRENT_COMPLETE: 94,
  ENTITY_HEADER: 89,
};

export function createShowOrganizer(body = {}) {
  return axiosRequest('post', serviceUrls.CMS_CREATE_SSIORGRANIZER, body);
}

export function persistShowOrganizer(body = {}) {
  return axiosRequest('post', serviceUrls.CMS_PERSIST_ORGANIZER, body);
}

export function submitShowOrganizer(body = {}) {
  return axiosRequest('post', serviceUrls.CMS_SUBMIT_ORGANIZER, body);
}

export function fetchShowOrganizer(params) {
  const isCalWP = sessionStorage.getItem('isCalWP');
  return axiosRequest('get', serviceUrls.CMS_GET_SHOWORGANIZER, {
    ...params,
    isCalWP,
  });
}

export function wpGetAuditLogReportList({ assigneeProfileId, organizerTypeId }) {
  return axiosRequest('get', serviceUrls.GET_AUTIDT_LOG_REPORT_LIST, {
    assigneeProfileId,
    organizerTypeId,
  });
}

export function fetchServiceInitiations(params, config) {
  return axiosRequest('post', serviceUrls.SSI_GET_LIST, params, config);
}

export function addCMSFile(data, config) {
  return axiosRequest('post', serviceUrls.CMS_FILE_UPLOAD, data, config || {});
}

export function addCMSFileIgnoreInterceptor(data, config) {
  return axiosRequest(
    'post',
    serviceUrls.CMS_FILE_UPLOAD,
    data,
    {
      ...config,
      timeout: 900000,
    },
    null,
    null,
    true,
  ).catch(e => e);
}

export function removeCMSFile(data) {
  return axiosRequest('post', serviceUrls.CMS_FILE_REMOVE, data);
}

export function downloadCMSFile(data) {
  return axiosRequest('get', serviceUrls.CMS_FILE_DOWNLOAD, data, {
    timeout: 180000,
  });
}

export function unlockQuestionnaire(personId, assigneeServicePlanGlobalIdOld) {
  const organizerTypeId = sessionStorage.getItem('organizerTypeId');
  const assigneeServicePlanGlobalId = sessionStorage.getItem('assigneeProfileId');

  const headerParams = {
    assigneeServicePlanGlobalId: parseInt(assigneeServicePlanGlobalId, 10),
    organizerTypeId: parseInt(organizerTypeId, 10),
  };
  return axiosRequest(
    'post',
    serviceUrls.CMS_SAVE_GOACCESS_DETAILS,
    {
      personId,
      forceAccessCleanup: true,
      ...headerParams,
    },
    null,
    null,
    headerParams,
  );
}

export function getWorkPaperUrl(data = {}) {
  return axiosRequest('post', serviceUrls.GET_WORKPAPER_URL, data);
}

export function getProductListByOrgYearService(data = {}) {
  return axiosRequest('post', serviceUrls.GET_PRODUCT_LIST_BY_ORG_YEAR, data, null, null, data);
}

export function fetchPreproformaXML({ assigneeServicePlanGlobalId, organizerTypeId, yearTypeId, year }) {
  return axiosRequest(
    'get',
    serviceUrls.DOWNLOAD_PREPROFORMA_XML,
    {
      assigneeServicePlanGlobalId,
      organizerTypeId,
      yearTypeId,
      year: year || 2017, // hardcoded for now
    },
    { timeout: 180000 },
  );
}

export function fetchDownloadSummaryPDF({ assigneeServicePlanGlobalId, organizerTypeId, yearTypeId, year, isCalWP }) {
  return axiosRequest(
    'get',
    serviceUrls.DOWNLOAD_ORGANIZER_SUMMARY,
    {
      assigneeServicePlanGlobalId,
      organizerTypeId,
      yearTypeId,
      year: year || 2017,
      isCalWP,
    },
    { timeout: 180000 },
  );
}

export function fetchAnswerkeyXML({ assigneeServicePlanGlobalId, organizerTypeId, yearTypeId, year }) {
  return axiosRequest(
    'get',
    serviceUrls.DOWNLOAD_ANSWERKEY_XML,
    {
      assigneeServicePlanGlobalId,
      organizerTypeId,
      yearTypeId,
      year: year || 2017, // hardcoded for now
    },
    { timeout: 180000 },
  );
}

export function reassignCase() {
  const assigneeServicePlanGlobalId = sessionStorage.getItem('assigneeServicePlanGlobalId');
  const organizerTypeId = sessionStorage.getItem('organizerTypeId');
  const yearTypeId = sessionStorage.getItem('yearTypeId');
  return axiosRequest('get', serviceUrls.CMS_REASSIGNCASE, {
    assigneeServicePlanGlobalId,
    organizerTypeId,
    yearTypeId,
  });
}

export function downloadXMLFile({ elementName }) {
  const assigneeServicePlanGlobalId = sessionStorage.getItem('assigneeServicePlanGlobalId');
  const organizerTypeId = sessionStorage.getItem('organizerTypeId');
  const yearTypeId = sessionStorage.getItem('yearTypeId');
  return axiosRequest('get', serviceUrls.CMS_XML_DOWNLOAD, {
    assigneeServicePlanGlobalId,
    organizerTypeId,
    yearTypeId,
    elementName,
  });
}
export function downloadPDFFile(data) {
  return axiosRequest('get', serviceUrls.CMS_PDF_DOWNLOAD, data);
}

export const persistOrg = (formValues, isFormComplete, page, callback = () => {}) => async dispatch => {
  // there's nothing to save on a menu page. we'll revisit this later
  const { organizerInstanceId, assigneeServicePlanGlobalId, yearTypeId, organizerTypeId, pageId, sourceTableId } = page;
  const pageState = isFormComplete ? CREATEORGANIZER_PAGESTATES.COMPLETE : CREATEORGANIZER_PAGESTATES.CURRENT_NOT_COMPLETE;
  const orgOptions = {
    assigneeServicePlanGlobalId,
    organizerInstanceId,
    organizerTypeId,
    yearTypeId,
    pageId,
    pageSourceId: sourceTableId,
    languageId: 1,
    pageState,
    ...transformFormValues(formValues),
  };
  return persistShowOrganizer(orgOptions);
};

export function downloadQuestionnaire({ assigneeServicePlanGlobalId, organizerTypeId, yearTypeId, languageId, isCalWP }) {
  return axiosRequest(
    'get',
    serviceUrls.QUESTIONNAIRE_DOWNLOAD,
    {
      assigneeServicePlanGlobalId,
      organizerTypeId,
      yearTypeId,
      languageId,
      isCalWP,
    },
    { timeout: 180000 },
  );
}



// WEBPACK FOOTER //
// ./src/services/cms.service.js